var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 110,
    viewBox: "0 0 142 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8521_58523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.797 88.3107L100.026 54.9699C97.3765 52.5205 94.1848 51.2657 90.933 51.2657C87.621 51.2657 84.6703 52.4007 81.9 54.8506L54.6801 78.9898L43.5395 69.0117C41.0102 66.7407 38.2401 65.6058 35.4097 65.6058C32.6998 65.6058 30.1103 66.6811 27.6413 68.9515L4.6972 89.5059C5.05853 100.321 9.51484 105.818 18.4877 105.818H119.417C130.317 105.818 135.797 99.7827 135.797 88.3107ZM18.9093 110H123.091C135.737 110 142 103.846 142 91.5372V18.5225C142 6.21402 135.737 0 123.091 0H18.9093C6.32316 0 0 6.21402 0 18.5225V91.5372C0 103.846 6.32316 110 18.9093 110ZM19.0297 100.38C13.0076 100.38 9.69552 97.2135 9.69552 90.9998V19.0603C9.69552 12.8463 13.0076 9.61979 19.0297 9.61979H122.97C128.932 9.61979 132.305 12.8463 132.305 19.0603V90.9998C132.305 97.2135 128.932 100.38 122.97 100.38H19.0297Z",
    fill: "#DDDDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8644 55.5676C52.6329 55.5676 59.0164 49.2343 59.0164 41.4667C59.0164 33.759 52.6329 27.3657 44.8644 27.3657C37.0357 27.3657 30.6523 33.759 30.6523 41.4667C30.6523 49.2343 37.0357 55.5676 44.8644 55.5676Z",
    fill: "#DDDDE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8521_58523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no_image.c733ff9d496fee4ae8eb2fced91c5f0b.svg";
export { ForwardRef as ReactComponent };